<template>
  <div id="footer" class="acea-row row-middle" style="background-color:#FFFFFF">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div class="iconfont">
        <img
          :src="getThumb(item.src1, item.src2, item.url === $route.path)"
          style="height: 3vh"
        />
      </div>

      <div>
        <font :color="getColor(item.url === $route.path)">{{ item.name }}</font>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "FooterNew",
  props: {},
  data: function() {
    return {
      font_color: "white",
      footerList: [
        {
          name: "首页",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          src1: "xxpd",
          src2: "xxpd_new",
          url: "/"
        },
        {
          name: "发现",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/find",
          src1: "grb",
          src2: "grb_new"
        },
        {
          name: "发布",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/participateIn",
          src1: "jfsc",
          src2: "jfsc_new"
        },
        {
          name: "消息",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/message",
          src1: "wd",
          src2: "wd_new"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user_ej",
          src1: "wd",
          src2: "wd_new"
        }
      ]
    };
  },
  methods: {
    getThumb(type, type1, ck) {
      let thumb = {
        xxpd: require("@assets/home_new/menu1.png"),
        grb: require("@assets/home_new/menu2.png"),
        jfsc: require("@assets/home_new/menu3.png"),
        wd: require("@assets/home_new/menu4.png"),
        xxpd_new: require("@assets/home_new/menu1.png"),
        grb_new: require("@assets/home_new/menu2.png"),
        jfsc_new: require("@assets/home_new/menu3.png"),
        wd_new: require("@assets/home_new/menu4.png")
      };
      // console.log("ck:::::"+ck)
      if (ck) {
        return thumb[type1];
      } else {
        return thumb[type];
      }
    },
    getColor(ck) {
      if (ck) {
        return "#3074e7";
      } else {
        return "#333333";
      }
    }
  }
};
</script>
